export default __webpack_public_path__ + "static/media/r.9da7c10d.wav";